import React from "react"
import styled from "styled-components"
import { Carousel as ResponsiveCarousel } from "react-responsive-carousel"

import { Box } from "components/box"
import Icon from "components/icon"

export const Container = styled(Box)`
  .carousel-root {
    outline: none;
  }

  .carousel.carousel-slider {
    display: inline-flex;
    box-sizing: border-box;
    position: relative;
    width: 100%;

    .slider-wrapper {
      overflow: hidden;
    }

    .slider {
      display: flex;
    }

    .control-dots {
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      width: 100%;

      position: absolute;
      bottom: -${props => props.theme.space[5]};

      .dot {
        position: relative;
        outline: none;
        cursor: pointer;
        transition: background 0.25s ease-in-out;

        background: ${props => props.theme.colors.silver};
        border-radius: 50%;

        width: ${props => props.theme.space[2]};
        height: ${props => props.theme.space[2]};
        margin: 0 ${props => props.theme.space[1]};
      }

      .dot.selected {
        background: ${props => props.theme.colors.evergreen};
      }
    }

    .slide {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      min-width: 100%;
    }
  }
`

export const CarouselArrow = styled(Icon)`
  cursor: pointer;
  display: none;

  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    display: block;
    align-self: center;
    position: static;
  }
`

type CarouselProps = Partial<GetComponentProps<ResponsiveCarousel>>

export const Carousel: React.FC<CarouselProps> = props => (
  <Container>
    <ResponsiveCarousel
      showArrows
      infiniteLoop
      showThumbs={false}
      showStatus={false}
      showIndicators
      renderArrowPrev={handleClick => <CarouselArrow name="previous" onClick={handleClick} mr={[0, 0, 6, 6]} />}
      renderArrowNext={handleClick => <CarouselArrow name="next" onClick={handleClick} ml={[0, 0, 6, 6]} />}
      {...props}
    />
  </Container>
)
